module.exports = __webpack_public_path__ + "static/fonts/382A4A_3_0.765b542.ttf";